var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('div',[_vm._v("Loading...")]):(_vm.isError)?_c('div',[_vm._v("Error: "+_vm._s(_vm.errorMessage))]):_c('div',[_c('SummaryContainer',{attrs:{"assessment":_vm.assessment}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }